import React, {Fragment} from 'react';
import classNames from 'classnames';
import PropTypes from "prop-types";
import { Tooltip } from 'react-tippy';

const mapping = {
    fa: {
        'circle-o': 'far fa-circle',
        'circle': 'fas fa-circle',
        'gear': 'fas fa-cog',
        'refresh': 'fas fa-sync-alt',
        'money': 'fas fa-money-check-alt'
    },
    material: {
        'bold': "format_bold",
        'italic': "format_italic",
        'underline': "format_underlined",
        'align-left': "format_align_left",
        'align-right': "format_align_right",
        'align-justify': "format_align_justify",
        'align-center': "format_align_center",
        'filter': "filter_list",
        'add-image': "add_to_photos",
        'insert-image': "add_photo_alternate",
        'upload': "file_upload",
        'edit': "mode_edit",
        'unlink': "link_off",
        'strike': "strikethrough_s"
    }
};

class Icon extends React.Component {

    static propTypes = {
        name: PropTypes.string,
        lib: PropTypes.string,
        spin: PropTypes.bool,
        className: PropTypes.any,
        style: PropTypes.any,
        onClick: PropTypes.func,
        tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.shape(Tooltip.propTypes)]),
    }

    render() {
        const disabled = this.props.disabled;
        let tooltip = {};
        if (typeof(this.props.tooltip) === "object" && !(this.props.tooltip || {}).props) {
            tooltip = {...this.props.tooltip, position: (this.props.tooltip || {}).position || "top", disabled: (this.props.tooltip || {}).disabled || disabled};
        } else {
            const html = this.props.tooltip instanceof Function ? this.props.tooltip() : this.props.tooltip;
            tooltip = {position: "top", disabled: disabled};
            if (html) {
                tooltip.html = html;
            } else {
                tooltip = {};
            }
        }

        const isTippy = Object.keys(tooltip).length;

        const Tag = isTippy ? Tooltip : (this.props.className || this.props.style ? "span" : null);

        const props = this.props;
        let icon = null;
        switch (props.lib) {
            case "fa":
                icon = <i
                    className={classNames((mapping.fa && mapping.fa[props.name] ? mapping.fa[props.name] : "fa fa-" + props.name), {"fa-spin": props.spin})} onClick={this.props.onClick}/>;
                break;
            case "fas":
            case "far":
            case "fal":
                icon = <i
                    className={classNames(props.lib + " fa-" + (mapping.fa && mapping.fa[props.name] ? mapping.fa[props.name] : props.name), {"fa-spin": props.spin})} onClick={this.props.onClick}/>;
                break;
            case "bq":
                icon = <i
                    className={classNames(props.lib + " bq-" + (mapping.bq && mapping.bq[props.name] ? mapping.bq[props.name] : props.name), {"bq-spin": props.spin})} onClick={this.props.onClick}/>;
                break;
            default:
                icon = <i className={classNames("material-icons", {
                    "fa-spin": props.spin
                })} onClick={this.props.onClick}>{mapping.material[props.name] ? mapping.material[props.name] : props.name}</i>;
                break;
        }
        return Tag ? <Tag {...(isTippy ? tooltip : {})} className={classNames(this.props.className)} style={this.props.style}>{icon}</Tag> : icon;
    }
}

export default Icon;